import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { UserFollowedByLoadPendingAction } from '../../domains/userFollowedBy/actions.types';
import {
  UserInsightsInfluenceLoadAction,
  UserInsightsInfluenceLoadFulfilledAction,
} from '../../domains/userInsightsInfluences/actions.types';
import { User } from '../users/types';

import { UserFollowedByNotFollowingBack, UsersFollowedByNotFollowingBack } from './types';

const initialState: UsersFollowedByNotFollowingBack = {};

const initialUserFollowedByNotFollowingBack: UserFollowedByNotFollowingBack = {
  id: '',
  followedByNotFollowingBack: [],
  cursor: null,
  hasNextPage: false,
  totalCount: 0,
  status: 'notRequested',
};

const stateWithPendingFollowedByNotFollowingBack = (
  state: UsersFollowedByNotFollowingBack,
  { id, isInitialLoad }: UserFollowedByLoadPendingAction['payload']
): UsersFollowedByNotFollowingBack => {
  const followedBy = isInitialLoad ? initialUserFollowedByNotFollowingBack : state[id];

  return addToRecord(state, id, { ...followedBy, status: 'pending' });
};

const stateWithFulfilledFollowedByNotFollowingBack = (
  state: UsersFollowedByNotFollowingBack,
  { id, entities, isInitialLoad }: UserInsightsInfluenceLoadFulfilledAction['payload']
): UsersFollowedByNotFollowingBack => {
  const {
    cursor,
    hasNextPage,
    totalCount,
    followedByNotFollowingBack: newFollowedByNotFollowingBack,
  } = entities.followedByNotFollowingBack[id];
  const followedByNotFollowingBack = isInitialLoad
    ? newFollowedByNotFollowingBack
    : [...state[id].followedByNotFollowingBack, ...newFollowedByNotFollowingBack];

  const fulfilledFollowedByNotFollowingBack: UserFollowedByNotFollowingBack = {
    id,
    followedByNotFollowingBack: [...new Set(followedByNotFollowingBack)],
    cursor,
    hasNextPage,
    totalCount,
    status: 'fulfilled',
  };

  return addToRecord(state, id, fulfilledFollowedByNotFollowingBack);
};

const stateWithRejectedFollowedByNotFollowingBack = (
  state: UsersFollowedByNotFollowingBack,
  id: User['id']
): UsersFollowedByNotFollowingBack => updateRecord(state, id, { status: 'rejected' });

const reducer: Reducer<UsersFollowedByNotFollowingBack, UserInsightsInfluenceLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'USER_INSIGHTS_INFLUENCE.LOAD_PENDING':
      return stateWithPendingFollowedByNotFollowingBack(state, action.payload);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_FULFILLED':
      return stateWithFulfilledFollowedByNotFollowingBack(state, action.payload);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_REJECTED':
      return stateWithRejectedFollowedByNotFollowingBack(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;
